import React , {Component} from 'react';
import Header from '../common/Header/HeaderMain';
import Footer from '../common/Footer/FooterMain';
import FeedbackMain from '../Feedback/FeedbackMain';
import ThankyouPage from '../common/ThankyouPage/Thankyou'
import {fetchFeedbackData , updateFeedbackResponse} from '../../../dataFetchers/feedbackDataFetcher';
import { connect } from 'react-redux';
import BCLLoading from '../../common/Loading/BCLLoading';
import { trackEvent } from '../../../helpers/analyticsHelper';
import { PAGE_EVENT_NAMES, WIDGETS } from '../../../constants/common';
import { withLastLocation } from "react-router-last-location";
import { isPreview } from '../../../helpers/authHelper';


class FeedbackContainer extends Component {

    constructor(props){
        super(props);
        this.state={
            params : {
                'feedback-type' : null,
                'event-type' : null,
                'locale' : null,
                'delivery-mode' : null
            },
            uuid: this.props.userObj.details.uuid,
            locale: this.props.queryParams.locale
        }
    }

    componentDidMount(){
        trackEvent(this.state.uuid, PAGE_EVENT_NAMES.FEEDBACK , {
            viewed : true,
            locale : this.state.locale
        },this.props)

        if(!this.props.feedbackData){
            let params ={
                'feedback-type' : this.props.queryParams.feedbackType,
                'event-type' : this.props.queryParams.eventType,
                'locale' : this.props.queryParams.locale,
                'delivery-mode' : this.props.queryParams.deliveryMode
            }
            if(isPreview()){
                params.templateName = `${WIDGETS.FEEDBACK}`;
            }
            this.setState({params: Object.assign({}, params)});
            this.props.fetchFeedbackData(this.props.userData.userId, params);
        }
    }

    render() {
        let feedbackBody = (
                <div className="feedback">
                    <Header
                     configs={this.props.configs}
                      />
                    {this.props.feedbackData !=null && !this.props.feedbackSubmitted && this.props.userObj ?
                        <FeedbackMain
                            feedbackData={this.props.feedbackData}
                            onSubmit={(data) => this.props.updateFeedbackResponse(this.props.userData.userId, data, Object.assign({}, this.state.params))}
                            userData={this.props.userData}
                            userObj={this.props.userObj}
                            translations={this.props.translations}
                            queryParams={this.props.queryParams}/> :
                    (this.props.feedbackSubmitted) &&
                        <ThankyouPage
                            userObj={this.props.userObj}
                            translations={this.props.translations}/>}
                    <Footer
                        uuid={this.props.userObj.details.uuid}
                        configs={this.props.configs}
                        translations={this.props.translations}
                        footerNote={this.props.translations.data["FOOTER.STANDALONE_PAGE.FOOTER_NOTE"]}
                        queryParams={this.props.queryParams}
                     />
                </div>
        );
        return (
            <>
            {this.props.feedbackData && this.props.configs && this.props.translations?feedbackBody:<BCLLoading />}
            </>
        )
    }
}

const mapStateToProps = state => {
    return{
        userObj: state.userObject,
        feedbackSubmitted : state.feedbackData.feedbackSubmitted,
        feedbackData : state.feedbackData.data,
        userData: state.userIdentityDetails,
        configs: state.configs,
        translations: state.translationsData,
        queryParams: state.queryParams

    }
}
const mapDispatchToProps = dispatch => {
    return{
        fetchFeedbackData : (uuid,options) => dispatch(fetchFeedbackData(uuid,options)),
        updateFeedbackResponse : (uuid, data,params) => dispatch(updateFeedbackResponse(uuid, data,params)),

    }
}
export default withLastLocation(connect(mapStateToProps, mapDispatchToProps)(FeedbackContainer));